import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/feedback";
import { enRouteOptions } from "@/lib/route-i18n";

export const Route = createFileRoute("/en/feedback")(
  enRouteOptions(routeOptions, {
    svPath: "/feedback",
    title: 'Feedback – Alkoholprovet',
    description: 'Tell us what you think about Alkoholprovet.',
    noindex: true,
  }),
);
